export const TransferDecisionEN = {
    "decisionTransfer":{
        "title": {
            "add": "Create transfer decision",
            "update": "Update transfer decision",
            "detail": "Detail transfer decision"
        },
    }
}